import type { JSX } from 'react';

import { DocumentApi } from 'Api/Document/DocumentApi';
import { GovernanceLibraryTable, GovernanceLibraryTableProps } from 'Components/Governance/GovernanceLibraryTable/GovernanceLibraryTable';
import { GovernanceVersion, TextBasedGovernanceVersion } from 'Models/Governance';
import { OperationalControl } from 'Models/OperationalControls';

export interface RetiredGovernanceTabProps {
    documentApi: DocumentApi;
    governanceItems: GovernanceVersion[];
    openExternalUrl: (url: string) => void;
    displayGovernanceTextModal: (governance: TextBasedGovernanceVersion) => void;
    displayAssociatedControlsModal: (controls: OperationalControl[]) => void;
}

export const RetiredGovernanceTab = (props: RetiredGovernanceTabProps): JSX.Element => {
    const governanceListingTableProps: GovernanceLibraryTableProps = {
        documentApi: props.documentApi,
        governanceItems: props.governanceItems,
        governanceItemsAreManageable: false,
        openExternalUrl: props.openExternalUrl,
        displayGovernanceTextModal: props.displayGovernanceTextModal,
        displayAssociatedControlsModal: props.displayAssociatedControlsModal,
    };

    return <GovernanceLibraryTable {...governanceListingTableProps} />;
};
